import { render, staticRenderFns } from "./staticMotion.vue?vue&type=template&id=e97c670c&scoped=true"
import script from "./staticMotion.vue?vue&type=script&lang=js"
export * from "./staticMotion.vue?vue&type=script&lang=js"
import style0 from "./staticMotion.vue?vue&type=style&index=0&id=e97c670c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97c670c",
  null
  
)

export default component.exports